import { initialize } from '@va/dashboard/actions/app';
import { setWindowWidth } from '@va/dashboard/actions/ui';
import { Config as BaseConfig } from '@va/http-client';
import { createStore } from '@va/store';
import '@va/styles/index.scss';
import '@va/styles/tailwind.css';
import { isUserLoggedInWithCustomUrl } from '@va/standalone/shared/helpers';
import { debounce, initializeFlagsmith, logVersion, setDefaultTheme } from '@va/util/helpers';
import Config from 'Config';
import 'react-loading-skeleton/dist/skeleton.css';
import { Store } from 'redux';
import rootReducer from './reducers/rootReducer';
import rootSaga from './sagas/rootSaga';

export const initializeApp = () => {
  logVersion();
  const store = createStore(rootReducer, rootSaga);

  const getAuthenticateHeaders = (store: Store) => () => {
    const state = store.getState();

    const auth = state.getIn(['core', 'authentication']).toJS();
    const headers: {
      Authorization?: string;
    } = {};

    if (auth.token) {
      headers['Authorization'] = 'Bearer ' + auth.token;
    }

    return headers;
  };

  setDefaultTheme();
  initializeFlagsmith(isUserLoggedInWithCustomUrl() ? window.location.origin : undefined);

  BaseConfig.setApiBaseUrl(Config.apiUrl);
  BaseConfig.setAuthProvider(getAuthenticateHeaders(store));
  store.dispatch(setWindowWidth(window.innerWidth));
  store.dispatch(initialize());

  window.addEventListener(
    'resize',
    debounce(() => {
      store.dispatch(setWindowWidth(window.innerWidth));
    }, 150),
  );

  return store;
};
